import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=4bad8156&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=ts&"
export * from "./scale.vue?vue&type=script&lang=ts&"
import style0 from "./scale.vue?vue&type=style&index=0&id=4bad8156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad8156",
  null
  
)

export default component.exports